import { Routes } from '@angular/router';
import { authGuard } from '@core/guards';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () => import('./pages/main/main.component').then(m => m.MainComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'tenants',
        pathMatch: 'full'
      },
      {
        path: 'tenants',
        loadComponent: () => import('./pages/tenants/tenants.component').then(m => m.TenantsComponent)
      },
      {
        path: ':id/settings',
        loadComponent: () => import('./pages/settings/settings.component').then(m => m.SettingsComponent)
      },
      {
        path: ':id/jobs',
        loadComponent: () => import('./pages/tenant-jobs/tenant-jobs.component').then(m => m.TenantJobsComponent),
        data: {
          buttonLabel: 'Create job'
        }
      },
      {
        path: ':id/jobs/:jobId',
        loadComponent: () => import('./pages/tenant-jobs/tenant-job/tenant-job.component').then(m => m.TenantJobComponent)
      }
    ]
  },
  {
    path: 'auth-callback',
    loadComponent: () => import('./pages/auth-callback/auth-callback.component').then(m => m.AuthCallbackComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'access-denied',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    data: {
      accessDenied: true
    }
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
